var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_52_1",
    "data-name": "Component 52 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.629,
    height: 188.375,
    viewBox: "0 0 270.629 188.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.051,
    y1: 0.038,
    x2: 0.107,
    y2: 1.058,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a71ef"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg",
    x: 115.199,
    y: 72.819,
    width: 128.069,
    height: 95.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b1c5f7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-2",
    x: 115.199,
    y: 72.819,
    width: 128.069,
    height: 95.845,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b1c5f7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#bg)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-3",
    "data-name": "bg",
    width: 92.069,
    height: 59.845,
    rx: 5,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1,
    y1: -0.072,
    x2: 0.432,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd79a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.059,
    y1: -0.068,
    x2: 0.185,
    y2: 0.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07590"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Oval",
    x: 192.378,
    y: 98.688,
    width: 77.221,
    height: 77.221,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7c8cba",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M63.756,99.563A50.638,50.638,0,1,0,1.738,63.755,50.638,50.638,0,0,0,63.756,99.563Z",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.11,
    y1: 0.748,
    x2: 0.964,
    y2: 0.206,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be80ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1a6ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,14.092A50.866,50.866,0,0,0,8.784,42.618l26.577-25.6-4.691-3.806a7.873,7.873,0,0,1-11.582-9.4L14.4,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.31,
    y1: -0.344,
    x2: 2.261,
    y2: 1.322,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M57.811,20.7a50.391,50.391,0,0,0-5.222-6.173A23.183,23.183,0,1,1,9.793,0,51.285,51.285,0,0,0,3.526,1.266c-.55.145-1.094.306-1.633.47A29.538,29.538,0,1,0,57.811,20.691",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.789,
    y1: -1.178,
    x2: 1.669,
    y2: 2.023,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,0,21.711,12.535,43.422,25.07,21.712,37.6,0,50.139V0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.461,
    y1: 1.119,
    x2: -0.769,
    y2: -0.317,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48dd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4afd3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M31.64.292l5.708,3.3A29.542,29.542,0,0,1,0,8.044V0A23.179,23.179,0,0,0,31.64.29",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.412,
    y1: 0.5,
    x2: 1.362,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M59.509,17.787A50.86,50.86,0,0,0,69.75,2.8,134.127,134.127,0,0,0,40.782.011C18.259.011,0,4.226,0,9.423s18.259,9.414,40.782,9.414a159.807,159.807,0,0,0,18.727-1.05",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.168,
    y1: -5.608,
    x2: 1.218,
    y2: 7.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a66ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c48ec1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.731,27.467A13.733,13.733,0,1,1,27.461,13.736,13.746,13.746,0,0,1,13.731,27.467Zm0-19.918a6.182,6.182,0,1,0,5.711,3.817A6.193,6.193,0,0,0,13.731,7.548Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.347,
    y1: 0.011,
    x2: 0.682,
    y2: 1.082,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M3.95,6.4,10.042.306a1.065,1.065,0,0,1,1.506,1.506L4.905,8.453a1.015,1.015,0,0,1-.176.231,1.136,1.136,0,0,1-1.561,0A1.015,1.015,0,0,1,3,8.453L.288,5.747a1.065,1.065,0,0,1,1.5-1.506Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.507,
    y1: 2.102,
    x2: 0.496,
    y2: -0.393,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M3.973,6.4,10.065.306A1.065,1.065,0,0,1,11.57,1.811L4.928,8.453a1.028,1.028,0,0,1-.176.232,1.14,1.14,0,0,1-1.561,0,1.015,1.015,0,0,1-.174-.232L.312,5.747a1.064,1.064,0,0,1,1.5-1.5Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.507,
    y1: 2.1,
    x2: 0.496,
    y2: -0.394,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M3.95,6.4,10.042.306a1.065,1.065,0,0,1,1.506,1.506L4.905,8.455a1.015,1.015,0,0,1-.176.231,1.136,1.136,0,0,1-1.561,0A1.015,1.015,0,0,1,3,8.455L.288,5.748a1.065,1.065,0,0,1,1.5-1.506Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M17.447,0c9.636,0,17.447,2.263,17.447,5.055S27.082,10.11,17.447,10.11,0,7.847,0,5.055,7.812,0,17.447,0",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.167,
    y1: -4.789,
    x2: 1.219,
    y2: 6.206,
    xlinkHref: "#linear-gradient-10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval-2",
    "data-name": "Oval",
    d: "M68.051,117.184C30.713,117.184,0,102.115,0,66.209S29.355,9.75,67.606,1.195c27.438-6.137,48.186,12.2,58.918,35.914,4.229,9.347,8.688,18.95,8.688,29.1C135.212,102.115,105.388,117.184,68.051,117.184Z",
    transform: "translate(13.508)",
    fill: "#f7f8fe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic",
    transform: "translate(80.72 6.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-3",
    "data-name": "Oval",
    d: "M94.33,164.588c52.442,0,95.579-21.165,95.579-71.6s-41.23-79.3-94.955-91.314C56.417-6.941,27.276,18.807,12.2,52.12,6.262,65.249,0,78.736,0,92.992,0,143.423,41.888,164.588,94.33,164.588Z",
    transform: "translate(0 15.98)",
    fill: "#f7f8fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(52.48 72.799)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -133.2, -78.82)",
    filter: "url(#bg-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-4",
    "data-name": "bg",
    width: 92.069,
    height: 59.845,
    rx: 5,
    transform: "translate(133.2 78.82)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Card-2",
    "data-name": "Card",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_9",
    "data-name": "Rectangle Copy 9",
    width: 16.112,
    height: 5.754,
    transform: "translate(27.621 33.375)",
    fill: "#fff",
    opacity: 0.504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_5",
    "data-name": "Rectangle Copy 5",
    width: 16.112,
    height: 5.754,
    transform: "translate(5.754 33.375)",
    fill: "#fff",
    opacity: 0.504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 93.22,
    height: 9.207,
    transform: "translate(0 12.659)",
    fill: "#fff",
    opacity: 0.409
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "$",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 102.607, 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 15.356,
    cy: 15.868,
    rx: 15.356,
    ry: 15.868,
    transform: "translate(1.024 0)",
    fill: "#f08762"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    "data-name": "Oval",
    cx: 14.844,
    cy: 15.868,
    rx: 14.844,
    ry: 15.868,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5.8,15.868H4.383v-1.9A12.039,12.039,0,0,1,.044,13.15v-2.5a12.921,12.921,0,0,0,2.13.722,12.609,12.609,0,0,0,2.216.367V8.8l-.71-.247A7.713,7.713,0,0,1,.839,6.939,2.953,2.953,0,0,1,0,4.789a2.736,2.736,0,0,1,1.15-2.257,6.01,6.01,0,0,1,3.21-1.076V0H5.782V1.416a12,12,0,0,1,4.2.875L9.028,4.507a11.48,11.48,0,0,0-3.246-.741v2.8A15.912,15.912,0,0,1,8.624,7.8,3.779,3.779,0,0,1,9.852,8.943a2.706,2.706,0,0,1,.384,1.462,2.958,2.958,0,0,1-1.165,2.424A6.054,6.054,0,0,1,5.8,13.924v1.943ZM5.832,9.3v2.364c.908-.152,1.349-.519,1.349-1.121H7.21a.826.826,0,0,0-.341-.668A4.7,4.7,0,0,0,5.832,9.3ZM4.44,3.787c-.9.14-1.335.467-1.335,1h.029a.87.87,0,0,0,.306.668,3.745,3.745,0,0,0,1,.555Z",
    transform: "translate(10.238 7.934)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons_Check-input",
    "data-name": "Icons/Check-input",
    transform: "translate(129.658 110.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -210.38, -116.69)",
    filter: "url(#Oval)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    "data-name": "Oval",
    cx: 20.61,
    cy: 20.61,
    r: 20.61,
    transform: "translate(210.38 116.69)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M23.258,1.718a1,1,0,0,1,0,1.423L8.907,17.371a1.02,1.02,0,0,1-1.435,0L.3,10.256a1,1,0,0,1,0-1.423L1.732,7.41a1.021,1.021,0,0,1,1.435,0L8.19,12.391l12.2-12.1a1.02,1.02,0,0,1,1.435,0Z",
    transform: "translate(8.833 12.759)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle_copy_3",
    "data-name": "circle copy 3",
    cx: 6.801,
    cy: 6.801,
    r: 6.801,
    transform: "translate(62.248 167.753)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle_copy_4",
    "data-name": "circle copy 4",
    cx: 4.534,
    cy: 4.534,
    r: 4.534,
    transform: "translate(136.102 47.477)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.364
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "budget-planner-icon",
    transform: "translate(0 29.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(23.294 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M63.756,99.563A50.638,50.638,0,1,0,1.738,63.755,50.638,50.638,0,0,0,63.756,99.563Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-2",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 112.301,
    height: 112.303,
    transform: "translate(-5.5 -5.501)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-3",
    "data-name": "Clipped",
    transform: "translate(23.296 36.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M0,14.092A50.866,50.866,0,0,0,8.784,42.618l26.577-25.6-4.691-3.806a7.873,7.873,0,0,1-11.582-9.4L14.4,0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-4",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 35.36,
    height: 42.617,
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-5",
    "data-name": "Clipped",
    transform: "translate(57.312 0.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M57.811,20.7a50.391,50.391,0,0,0-5.222-6.173A23.183,23.183,0,1,1,9.793,0,51.285,51.285,0,0,0,3.526,1.266c-.55.145-1.094.306-1.633.47A29.538,29.538,0,1,0,57.811,20.691",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-6",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 57.814,
    height: 41.694,
    transform: "translate(-0.003 0.004)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-7",
    "data-name": "Clipped",
    transform: "translate(70.865 11.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M0,0,21.711,12.535,43.422,25.07,21.712,37.6,0,50.139V0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-8",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 43.422,
    height: 50.141,
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-9",
    "data-name": "Clipped",
    transform: "translate(70.865 29.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M31.64.292l5.708,3.3A29.542,29.542,0,0,1,0,8.044V0A23.179,23.179,0,0,0,31.64.29",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-10",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    width: 37.347,
    height: 12.735,
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-11",
    "data-name": "Clipped",
    transform: "translate(50.438 68.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M59.509,17.787A50.86,50.86,0,0,0,69.75,2.8,134.127,134.127,0,0,0,40.782.011C18.259.011,0,4.226,0,9.423s18.259,9.414,40.782,9.414a159.807,159.807,0,0,0,18.727-1.05",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-12",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    width: 69.75,
    height: 18.826,
    transform: "translate(0 0.011)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-13",
    "data-name": "Clipped",
    transform: "translate(36.032 29.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M13.731,27.467A13.733,13.733,0,1,1,27.461,13.736,13.746,13.746,0,0,1,13.731,27.467Zm0-19.918a6.182,6.182,0,1,0,5.711,3.817A6.193,6.193,0,0,0,13.731,7.548Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-14",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    "data-name": "Rectangle",
    width: 27.459,
    height: 27.461,
    transform: "translate(-0.001 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M6.862.007H42.254a6.883,6.883,0,0,1,6.861,6.861V57.94A6.883,6.883,0,0,1,42.254,64.8H6.862A6.883,6.883,0,0,1,0,57.94V6.861A6.883,6.883,0,0,1,6.862,0",
    transform: "translate(0 10.902)",
    fill: "#7f79d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    "data-name": "Rectangle",
    width: 37.202,
    height: 47.256,
    rx: 0.622,
    transform: "translate(5.96 22.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M25.264,9.555H0V7.283A2.171,2.171,0,0,1,2.159,5.122h7.12a3.658,3.658,0,1,1,6.7,0h7.121a2.171,2.171,0,0,1,2.159,2.162v2.27Zm-12.631-7.2a1.305,1.305,0,1,0,1.305,1.305A1.307,1.307,0,0,0,12.633,2.353Z",
    transform: "translate(12.386 5.012)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M1.246,0H27.422a1.249,1.249,0,0,1,1.246,1.246h0a1.249,1.249,0,0,1-1.246,1.246H1.246A1.249,1.249,0,0,1,0,1.246H0A1.249,1.249,0,0,1,1.246,0",
    transform: "translate(10.684 14.501)",
    fill: "#f99d9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-15",
    "data-name": "Clipped",
    transform: "translate(9.076 28.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    d: "M3.95,6.4,10.042.306a1.065,1.065,0,0,1,1.506,1.506L4.905,8.453a1.015,1.015,0,0,1-.176.231,1.136,1.136,0,0,1-1.561,0A1.015,1.015,0,0,1,3,8.453L.288,5.747a1.065,1.065,0,0,1,1.5-1.506Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-16",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    "data-name": "Rectangle",
    width: 12.087,
    height: 9.109,
    transform: "translate(-0.126 -0.108)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    d: "M.954,0H15.57a.954.954,0,0,1,0,1.909H.954A.954.954,0,1,1,.954,0",
    transform: "translate(23.546 34.956)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    d: "M.953,0H15.568a.956.956,0,0,1,.953.954h0a.956.956,0,0,1-.953.953H.953A.956.956,0,0,1,0,.954H0A.957.957,0,0,1,.953,0",
    transform: "translate(23.547 31.865)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    d: "M.917,0h9.6a.954.954,0,0,1,0,1.907H.917A.954.954,0,0,1,.917,0",
    transform: "translate(28.603 28.774)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-17",
    "data-name": "Clipped",
    transform: "translate(9.053 41.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    "data-name": "Path",
    d: "M3.973,6.4,10.065.306A1.065,1.065,0,0,1,11.57,1.811L4.928,8.453a1.028,1.028,0,0,1-.176.232,1.14,1.14,0,0,1-1.561,0,1.015,1.015,0,0,1-.174-.232L.312,5.747a1.064,1.064,0,0,1,1.5-1.5Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-18",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    "data-name": "Rectangle",
    width: 12.087,
    height: 9.109,
    transform: "translate(-0.103 -0.109)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    "data-name": "Path",
    d: "M15.568,1.907H.953A.956.956,0,0,1,0,.954H0A.957.957,0,0,1,.953,0H15.568a.957.957,0,0,1,.954.954h0a.957.957,0,0,1-.954.953",
    transform: "translate(23.547 42.011)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    d: "M15.57,1.909H.954A.954.954,0,1,1,.954,0H15.57a.954.954,0,0,1,0,1.909",
    transform: "translate(23.546 45.102)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-19",
    "data-name": "Clipped",
    transform: "translate(9.076 54.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    d: "M3.95,6.4,10.042.306a1.065,1.065,0,0,1,1.506,1.506L4.905,8.455a1.015,1.015,0,0,1-.176.231,1.136,1.136,0,0,1-1.561,0A1.015,1.015,0,0,1,3,8.455L.288,5.748a1.065,1.065,0,0,1,1.5-1.506Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-20",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    "data-name": "Rectangle",
    width: 12.087,
    height: 9.109,
    transform: "translate(-0.126 -0.109)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    d: "M15.568,1.906H.953A.956.956,0,0,1,0,.953H0A.956.956,0,0,1,.953,0H15.568a.956.956,0,0,1,.954.953h0a.957.957,0,0,1-.954.953",
    transform: "translate(23.547 55.251)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    d: "M15.532,1.908H.917A.954.954,0,0,1,.917,0H15.532a.954.954,0,1,1,0,1.907",
    transform: "translate(23.583 58.34)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    d: "M9.864,1.908H.917A.954.954,0,0,1,.917,0H9.864a.954.954,0,1,1,0,1.907",
    transform: "translate(23.583 61.432)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-30",
    "data-name": "Path",
    d: "M15.57,1.909H.954A.954.954,0,1,1,.954,0H15.57a.954.954,0,0,1,0,1.909",
    transform: "translate(23.546 48.194)",
    fill: "#d6e7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M25.042,66.63h0c-2.31-.085-4.135-.153-4.943-.153a20.9,20.9,0,0,1-10.422-2.6C4.388,60.834,1.2,55.38.194,47.668c-.849-6.523,1.089-13.4,5.759-20.446a60.041,60.041,0,0,1,10.61-11.9H33.522a59.964,59.964,0,0,1,10.61,11.9c4.671,7.043,6.609,13.923,5.759,20.449-1,7.712-4.19,13.165-9.48,16.209a20.905,20.905,0,0,1-10.424,2.6c-.819,0-2.73.071-4.943.153Zm9.312-54.977H15.731v-.013a71.615,71.615,0,0,1-5.446-7.906,5.217,5.217,0,0,1,4.378.668,4.616,4.616,0,0,0,2.25.64c1.69,0,2.993-1.089,4.52-2.512l.045-.042C23.257.831,24.15,0,25.041,0s1.79.837,3.575,2.5l.029.027c1.532,1.427,2.839,2.519,4.534,2.519a4.623,4.623,0,0,0,2.242-.634,5.22,5.22,0,0,1,4.38-.668,71.813,71.813,0,0,1-5.446,7.905Z",
    transform: "translate(63.296 18.271)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M15.088,63.113h0l-.2-.007c-2.212-.081-3.958-.144-4.74-.144H9.894A21.324,21.324,0,0,1,0,60.518a47.253,47.253,0,0,0,8.076.776c7.213,0,12.291-2.274,15.094-6.759a17.546,17.546,0,0,0,2.4-7.569,34.032,34.032,0,0,0-.373-8.8,62,62,0,0,0-5.361-16.558,17.48,17.48,0,0,1-1.783-9.8h5.512a59.968,59.968,0,0,1,10.61,11.9c4.671,7.043,6.608,13.923,5.759,20.449-1,7.712-4.189,13.165-9.479,16.209a20.9,20.9,0,0,1-10.424,2.6c-.791,0-2.571.065-4.823.147ZM24.4,8.12H18.871a23.354,23.354,0,0,1,3.571-6.68,4.288,4.288,0,0,0,.789.073A4.261,4.261,0,0,0,25.467.881,5.224,5.224,0,0,1,29.845.213,71.935,71.935,0,0,1,24.4,8.119Z",
    transform: "translate(73.246 21.791)",
    fill: "#f8aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M4.025,55.088A24.889,24.889,0,0,1,.194,44.149c-.849-6.524,1.089-13.4,5.759-20.446a60.086,60.086,0,0,1,10.61-11.9l3.769,0c-.34.415-.709.86-1.1,1.334l-.03.036c-7.022,8.47-21.634,26.1-15.172,41.918ZM19.337,8.12H15.73A71.729,71.729,0,0,1,10.284.213a5.222,5.222,0,0,1,4.378.668,4.932,4.932,0,0,0,1.785.607c-.047,2.589.415,5.839,2.891,6.629Z",
    transform: "translate(63.296 21.791)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-31",
    "data-name": "Path",
    d: "M2.3,4.6H19.215a2.3,2.3,0,0,0,2.3-2.3h0a2.3,2.3,0,0,0-2.3-2.3H2.3A2.3,2.3,0,0,0,0,2.3H0A2.3,2.3,0,0,0,2.3,4.6",
    transform: "translate(77.582 29.393)",
    fill: "#726dc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-32",
    "data-name": "Path",
    d: "M20.1.154A2.3,2.3,0,0,0,19.277,0H2.361a2.3,2.3,0,0,0-2.3,2.3h0A1.324,1.324,0,0,0,1.507,4.015H18.423A2.295,2.295,0,0,0,20.1.154",
    transform: "translate(77.519 29.393)",
    fill: "#9791df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-33",
    "data-name": "Path",
    d: "M19.888.154A2.3,2.3,0,0,0,19.063,0H10.424L2.3.519A2.36,2.36,0,0,0,0,2.817,1.2,1.2,0,0,0,.469,3.861a2.269,2.269,0,0,0,.825.154H18.21A2.295,2.295,0,0,0,19.89.154",
    transform: "translate(77.733 29.393)",
    fill: "#7f79d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-34",
    "data-name": "Path",
    d: "M0,.228C4.366,12.243,15.281,12.745,18.421,12.745c.344,0,.87.013,1.543.033a2.466,2.466,0,0,0-1.16-1.239L18.717,9.2c.979-.521,1.45-1.092,1.43-1.668q-.07-1.771-.135-3.545v.033c0-1.059-1.681-2.134-4.955-2.931A49.632,49.632,0,0,0,0,.223",
    transform: "translate(64.975 72.003)",
    fill: "#f6b5a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-35",
    "data-name": "Path",
    d: "M0,0A21.229,21.229,0,0,0,10.145,2.444c.344,0,.87.013,1.543.033a2.466,2.466,0,0,0-1.16-1.239l-.02-.556A41.755,41.755,0,0,1,0,0",
    transform: "translate(73.25 82.304)",
    fill: "#f9aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-36",
    "data-name": "Path",
    d: "M0,.084a20.919,20.919,0,0,0,2.356,4.66A21.374,21.374,0,0,1,1.024,0C.679.025.338.054,0,.084",
    transform: "translate(64.973 72.148)",
    fill: "#f9c6b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-21",
    "data-name": "Clipped",
    transform: "translate(50.68 87.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-37",
    "data-name": "Path",
    d: "M17.447,0c9.636,0,17.447,2.263,17.447,5.055S27.082,10.11,17.447,10.11,0,7.847,0,5.055,7.812,0,17.447,0",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped-22",
    "data-name": "Clipped",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    "data-name": "Rectangle",
    width: 34.893,
    height: 10.11,
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-38",
    "data-name": "Path",
    d: "M.574,3.046C.539,2.135.494.915.461,0,.483.63.549,2.321.574,2.974v.07",
    transform: "translate(56.2 89.248)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-39",
    "data-name": "Path",
    d: "M27.6.309l.126,3.368c.032.86-1.091,1.709-3.416,2.374a45.1,45.1,0,0,1-19.477.074C1.758,5.376.164,4.367.126,3.369L0,0C.038,1,1.63,2,4.711,2.756a45.089,45.089,0,0,0,19.476-.075C26.508,2.016,27.636,1.166,27.6.309",
    transform: "translate(54.277 88.897)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M14.283,7.256a45.218,45.218,0,0,1-9.57-1.026C1.738,5.505.021,4.495,0,3.457-.017,2.573,1.2,1.737,3.417,1.1a45.144,45.144,0,0,1,19.476-.077c2.974.724,4.692,1.735,4.712,2.773.018.884-1.2,1.721-3.417,2.357A45.189,45.189,0,0,1,14.283,7.256ZM13.4.623a37.462,37.462,0,0,0-8.2.91c-1.839.527-2.843,1.22-2.829,1.953.017.86,1.44,1.7,3.9,2.3a37.472,37.472,0,0,0,7.925.849,37.44,37.44,0,0,0,8.207-.912c1.84-.527,2.845-1.22,2.83-1.952-.017-.859-1.44-1.7-3.9-2.293A37.423,37.423,0,0,0,13.4.623Z",
    transform: "translate(54.276 85.423)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-40",
    "data-name": "Path",
    d: "M18.962.851c4.752,1.16,5.232,3.055,1.073,4.246A37.388,37.388,0,0,1,3.9,5.159C-.849,4-1.328,2.1,2.829.912A37.366,37.366,0,0,1,18.962.851",
    transform: "translate(56.647 86.047)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-41",
    "data-name": "Path",
    d: "M2.828,1.331A37.344,37.344,0,0,1,18.96,1.269c2.366.58,3.671,1.334,3.876,2.1.236-.9-1.078-1.839-3.876-2.52A37.413,37.413,0,0,0,2.828.911C.739,1.51-.178,2.287.028,3.059c.165-.63,1.089-1.239,2.8-1.728",
    transform: "translate(56.653 86.047)",
    fill: "#f89a0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-42",
    "data-name": "Path",
    d: "M0,0V3.3A13,13,0,0,0,3.519,4.6a36,36,0,0,0,5.132.812V2.057A36.309,36.309,0,0,1,3.391,1.23,13.345,13.345,0,0,1,0,.006",
    transform: "translate(55.596 90.427)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-43",
    "data-name": "Path",
    d: "M.574,3.046C.539,2.134.494.917.461,0,.482.63.549,2.321.575,2.975a.531.531,0,0,0,0,.068",
    transform: "translate(57.472 85.349)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-44",
    "data-name": "Path",
    d: "M27.6.309c.044,1.121.086,2.247.129,3.368.032.86-1.092,1.709-3.417,2.374a45.11,45.11,0,0,1-19.476.074C1.758,5.376.165,4.367.128,3.369L0,0C.038,1,1.63,2,4.711,2.756a45.1,45.1,0,0,0,19.477-.074C26.509,2.016,27.636,1.168,27.6.31",
    transform: "translate(55.55 84.998)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M14.284,7.256A45.183,45.183,0,0,1,4.712,6.228C1.738,5.5.021,4.495,0,3.457-.017,2.573,1.2,1.737,3.417,1.1a45.089,45.089,0,0,1,19.477-.074c2.974.724,4.691,1.735,4.711,2.772.018.883-1.2,1.72-3.416,2.355A45.152,45.152,0,0,1,14.284,7.256ZM13.4.622h0a37.466,37.466,0,0,0-8.2.91c-1.839.527-2.844,1.221-2.83,1.953.017.86,1.44,1.7,3.9,2.3a37.469,37.469,0,0,0,7.924.849,37.436,37.436,0,0,0,8.206-.912c1.84-.527,2.846-1.22,2.831-1.952-.017-.859-1.44-1.7-3.9-2.295A37.453,37.453,0,0,0,13.4.623Z",
    transform: "translate(55.548 81.524)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-45",
    "data-name": "Path",
    d: "M18.963.85c4.75,1.16,5.232,3.058,1.072,4.247A37.382,37.382,0,0,1,3.9,5.16C-.848,4-1.329,2.1,2.831.911A37.388,37.388,0,0,1,18.963.85",
    transform: "translate(57.923 82.149)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-46",
    "data-name": "Path",
    d: "M2.828,1.33A37.366,37.366,0,0,1,18.96,1.269c2.366.58,3.671,1.334,3.876,2.1.236-.9-1.078-1.838-3.876-2.518A37.388,37.388,0,0,0,2.828.911c-2.09.6-3.005,1.377-2.8,2.147.165-.628,1.089-1.237,2.8-1.728",
    transform: "translate(57.92 82.147)",
    fill: "#f89a0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-47",
    "data-name": "Path",
    d: "M0,0V3.3A13,13,0,0,0,3.52,4.6a36.117,36.117,0,0,0,5.13.814V2.058a36.274,36.274,0,0,1-5.258-.827A13.42,13.42,0,0,1,0,.007",
    transform: "translate(56.869 86.528)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-48",
    "data-name": "Path",
    d: "M.574,3.046C.539,2.135.494.915.461,0,.483.63.549,2.321.574,2.975v.07",
    transform: "translate(56.2 80.643)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-49",
    "data-name": "Path",
    d: "M27.6.31l.126,3.368c.032.859-1.091,1.709-3.416,2.374a45.144,45.144,0,0,1-19.477.073C1.758,5.376.164,4.367.126,3.369L0,0C.038,1,1.63,2,4.711,2.756a45.09,45.09,0,0,0,19.476-.074C26.508,2.016,27.636,1.166,27.6.31",
    transform: "translate(54.277 80.291)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M14.283,7.255A45.18,45.18,0,0,1,4.712,6.228C1.738,5.5.021,4.494,0,3.457-.017,2.573,1.2,1.737,3.417,1.1a45.124,45.124,0,0,1,19.476-.076c2.974.724,4.692,1.735,4.712,2.772.018.884-1.2,1.72-3.417,2.355A45.148,45.148,0,0,1,14.283,7.255ZM13.409.623A37.461,37.461,0,0,0,5.2,1.535c-1.839.527-2.843,1.22-2.829,1.952.017.859,1.44,1.7,3.9,2.295a37.381,37.381,0,0,0,7.923.851,37.409,37.409,0,0,0,8.209-.913c1.84-.526,2.845-1.219,2.83-1.951-.017-.86-1.44-1.7-3.9-2.3A37.432,37.432,0,0,0,13.409.623Z",
    transform: "translate(54.276 76.819)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-50",
    "data-name": "Path",
    d: "M18.962.85c4.752,1.16,5.232,3.058,1.073,4.247A37.343,37.343,0,0,1,3.9,5.159C-.849,4-1.328,2.1,2.829.912A37.388,37.388,0,0,1,18.962.85",
    transform: "translate(56.647 77.441)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-51",
    "data-name": "Path",
    d: "M2.828,1.331A37.366,37.366,0,0,1,18.96,1.269c2.366.58,3.671,1.336,3.876,2.1.236-.9-1.078-1.838-3.876-2.52A37.388,37.388,0,0,0,2.828.912C.739,1.511-.178,2.287.028,3.06c.165-.63,1.089-1.239,2.8-1.729",
    transform: "translate(56.653 77.441)",
    fill: "#f89a0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-52",
    "data-name": "Path",
    d: "M0,0V3.3A13,13,0,0,0,3.519,4.6a35.788,35.788,0,0,0,5.132.814V2.05a36.117,36.117,0,0,1-5.259-.825A13.465,13.465,0,0,1,0,0",
    transform: "translate(55.596 81.82)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-53",
    "data-name": "Path",
    d: "M27.6.306q.065,1.684.129,3.369c.032.86-1.092,1.709-3.417,2.374a45.135,45.135,0,0,1-19.476.074C1.758,5.373.165,4.365.128,3.368L0,0C.038,1,1.63,2,4.711,2.756a45.141,45.141,0,0,0,19.477-.075C26.509,2.016,27.636,1.166,27.6.308",
    transform: "translate(55.55 76.395)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M14.281,7.255A45.212,45.212,0,0,1,4.712,6.229C1.738,5.505.021,4.494,0,3.456-.017,2.572,1.2,1.735,3.417,1.1a45.15,45.15,0,0,1,19.477-.074c2.973.724,4.69,1.735,4.711,2.772.018.884-1.2,1.721-3.416,2.357A45.242,45.242,0,0,1,14.281,7.255ZM13.4.621h0a37.4,37.4,0,0,0-8.2.913c-1.84.527-2.845,1.22-2.83,1.952.017.86,1.44,1.7,3.9,2.294a37.379,37.379,0,0,0,7.922.851,37.407,37.407,0,0,0,8.208-.913c1.84-.526,2.845-1.219,2.831-1.951-.017-.86-1.44-1.7-3.9-2.294A37.4,37.4,0,0,0,13.405.622Z",
    transform: "translate(55.548 72.919)",
    fill: "#ffd5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-54",
    "data-name": "Path",
    d: "M18.963.851c4.75,1.16,5.232,3.056,1.072,4.247A37.336,37.336,0,0,1,3.9,5.159C-.848,4-1.329,2.1,2.831.912A37.343,37.343,0,0,1,18.963.851",
    transform: "translate(57.923 73.542)",
    fill: "#f9bba6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-55",
    "data-name": "Path",
    d: "M2.828,1.331A37.365,37.365,0,0,1,18.96,1.269c2.366.58,3.671,1.336,3.876,2.1.236-.9-1.078-1.841-3.876-2.521A37.388,37.388,0,0,0,2.828.912C.738,1.51-.178,2.287.028,3.06c.165-.63,1.089-1.24,2.8-1.729",
    transform: "translate(57.92 73.545)",
    fill: "#f8aeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-56",
    "data-name": "Path",
    d: "M0,0V3.3A12.992,12.992,0,0,0,3.52,4.6a35.907,35.907,0,0,0,5.13.812V2.055a36.484,36.484,0,0,1-5.258-.824A13.529,13.529,0,0,1,0,.006",
    transform: "translate(56.869 77.922)",
    fill: "#ffd5c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndImage);
export default __webpack_public_path__ + "static/media/end-image.6e7f1022951f52bd24fa814806fc9a2f.svg";
export { ForwardRef as ReactComponent };